import { parseCookies } from "nookies"
import {
  COMPANY_SETTINGS_SET_ENDPOINT,
  EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT,
  EDIT_TASK_ENDPOINT,
  GET_FILES_ENDPOINT,
  PROJECTS_BY_CURRENT_USER_FILTER,
  SERVER_URL,
  TASK_BY_CURRENT_USER_ENDPOINT,
  TASK_BY_ID_ENDPOINT,
  TASK_GROUP_ADD,
  TASK_SESSION_ADD_ENDPOINT,
  TASK_SESSION_DELETE_ENDPOINT,
  TASK_SESSION_FINISH_ENDPOINT,
} from "./api-routes"
import { ACCESS_TOKEN } from "./constants"
import {
  AnnotationFeature,
  CompanyAccessProps,
  DictType,
  EditProjectProps,
  GetLogsProps,
  GetMessagesProps,
  GetTasksProps,
  GlobalSearchOptions,
  Locale,
  MapAnnatotaions,
  ProjectProps,
  Task,
  TaskProps,
} from "@pma/types"
import axios from "axios"
import MapboxDraw from "@mapbox/mapbox-gl-draw"
import * as turf from "@turf/turf"

export async function getMessagesByCurrentUser({
  paging_per_page,
  paging_start_page,
  paging_offest,
  get_logs,
  type,
  organization_id,
}: GetMessagesProps) {
  try {
    const accessToken = parseCookies()[ACCESS_TOKEN]
    const url = SERVER_URL + "/messages_new/get/byCurrentUser1"
    let urlWithParams = new URL(url)

    // urlWithParams.searchParams.append("get_logs", get_logs.toString());
    urlWithParams.searchParams.append("type", type.toString())
    paging_per_page
      ? urlWithParams.searchParams.append("paging_per_page", paging_per_page.toString())
      : null
    paging_start_page
      ? urlWithParams.searchParams.append("paging_start_page", paging_start_page.toString())
      : null
    organization_id
      ? urlWithParams.searchParams.append("organization_id", organization_id.toString())
      : null

    const response = await axios.get(urlWithParams.toString(), {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
    return response.data
  } catch (error) {
    return error
  }
}

export async function getLogsByCurrentUser({
  paging_per_page,
  paging_start_page,
  type,
  organization_id,
}: GetLogsProps) {
  try {
    const accessToken = parseCookies()[ACCESS_TOKEN]

    const url = SERVER_URL + "/activites/get/byUser"
    const payload = {
      type: type,
      paging_per_page: paging_per_page,
      paging_start_page: paging_start_page,
      organization_id: organization_id,
    }

    const response = await axios.post(url, payload, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
    return response.data
  } catch (error) {
    return error
  }
}

export async function getDictionaryItemWithoutContext(endpoint: string, organizationId?: number) {
  try {
    const accessToken = parseCookies()[ACCESS_TOKEN]

    const url = SERVER_URL + endpoint
    const urlWithParams = new URL(url)
    organizationId &&
      urlWithParams.searchParams.append("organization_id", organizationId.toString())
    const response = await axios.get(urlWithParams.href, {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
    return response.data
  } catch (error) {
    return error
  }
}

export async function markMessageAsRead(messages_id: number[]) {
  const url = SERVER_URL + "/messages_new/markAsRead"
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.post(
    url,
    { message_id: messages_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response
}

export async function markMessageAsUnRead(messages_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/messages_new/markAsUnRead"
  const response = await axios.post(
    url,
    { message_id: messages_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function likeMessage(messages_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/messages_new/like"
  const response = await axios.post(
    url,
    { message_id: messages_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function unLikeMessage(messages_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/messages_new/unlike"
  const response = await axios.post(
    url,
    { message_id: messages_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function likeActivityApi(change_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/activites/like"
  const response = await axios.post(
    url,
    { change_id: change_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function unLikeActivityApi(change_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/activites/unlike"
  const response = await axios.post(
    url,
    { change_id: change_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function readActivityApi(change_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/activites/read"
  const response = await axios.post(
    url,
    { change_id: change_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function unReadActivityApi(change_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + "/activites/unread"
  const response = await axios.post(
    url,
    { change_id: change_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

// this functions returns tasks belongs to current user
export const deleteMessageById = async (messagesId: number[]) => {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const messageDeleteUrl = "/messages_new/delete/byRecipient"
    const response = await axios.post(
      SERVER_URL + messageDeleteUrl,
      {
        messages_id: messagesId,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "application/json",
        },
      },
    )
    return response
  } catch (error) {
    return error
  }
}

export async function deleteMessage(messages_id: number[]) {
  const accessToken = parseCookies()[ACCESS_TOKEN]
  const url = SERVER_URL + "/messages_new/delete/bySender"
  const response = await axios.post(
    url,
    { messages_id: messages_id },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function getFilteredProjectsByCurrentUser(body: ProjectProps) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const response = await axios.post(
      SERVER_URL + PROJECTS_BY_CURRENT_USER_FILTER,
      {
        ...body,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,

          "Content-Type": "application/json",
        },
      },
    )
    return response.data
  } catch (error) {
    console.log(error)
    return []
  }
}

export async function getOrganizationGlobalSearch(
  organizationId: string | number | null,
  searchText: string | null,
  options: GlobalSearchOptions,
) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const url = SERVER_URL + `/search`
  const response = await axios.post(
    url,
    {
      search_text: searchText,
      organization_id: organizationId,
      ...options,
    },
    {
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    },
  )
  return response.data
}

export async function getTasks({ pageParam, organizationId }: GetTasksProps) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const response = await axios.post(
      SERVER_URL + TASK_BY_CURRENT_USER_ENDPOINT,
      {
        show_created_by: true,
        organization_id: organizationId,
        paging_start_page: pageParam,
        paging_per_page: 10,
        show_deleted: false,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,

          "Content-Type": "application/json",
        },
      },
    )
    return response.data
  } catch (error) {
    console.log(error)
  }
}

export const getAnnotations = async (file_id: number) => {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const response = await axios.get(SERVER_URL + GET_FILES_ENDPOINT + `${file_id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    return response.data.annotations
  } catch (error) {
    console.error(error)
  }
}

export const getUserandTask = (r: Array<Task>) => {
  const userTasks: Record<number, any> = {}
  r?.forEach((task) => {
    task?.responsible_id?.forEach((user) => {
      const userId = user.id
      if (!userTasks[userId]) {
        userTasks[userId] = {
          user: {
            id: user.id,
            name: user.name,
            email: user.email,
            url: user.user_picture ? user.user_picture.url : "",
          },
          tasks: [],
        }
      }

      // add task for every  user

      userTasks[userId].tasks.push({
        id: task.id,
        uqId: task.id + userId,
        title: task.title,
        dec: task.description,
        status: task.status,
        responsible_id: task.responsible_id,
        user: user,
        notes_id: task?.notes_id,
        _subtasks: task?._subtasks,
        linked_files_id: task?.linked_files_id,
      })
    })
  })

  const userTasksCollection = Object.values(userTasks)
  return userTasksCollection
}

export const groupTaskByStatus = (tasks: Task[]) => {
  const taskByStatus: Record<number, any> = {}
  tasks?.forEach((task) => {
    const statusId = task?.status?.id

    // Create a status object if it doesn't exist in tasksByStatus
    if (!taskByStatus[statusId]) {
      taskByStatus[statusId] = {
        statuses: task.status,
        tasks: [],
        users: task.responsible_id,
      }
    }

    // Add the task to the tasks array for the corresponding status
    taskByStatus[statusId].tasks.push({
      ...task,
      id: task.id,
      title: task.title,
      dec: task.description,
      users: task.responsible_id,
      status_id: statusId,
      notes_id: task?.notes_id,
      _subtasks: task?._subtasks,
      linked_files_id: task?.linked_files_id,
    })
  })
  const projectTaskByStatus = Object.values(taskByStatus)
  return projectTaskByStatus
}

export async function editProjectByCurrentUser(propsToEdit: EditProjectProps) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const response = await axios.post(
      SERVER_URL + EDIT_PROJECT_BY_CURRENT_USER_ENDPOINT,
      {
        ...propsToEdit,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    )
    return response
  } catch (error) {
    return error
  }
}

export async function editTaskByCurrentUser(taskId: number, propsToEdit: TaskProps) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.post(
    SERVER_URL + EDIT_TASK_ENDPOINT,
    {
      title: propsToEdit.title,
      description: propsToEdit.description,
      status_id: propsToEdit.status_id,
      start_at: propsToEdit.start_at,
      finish_to: propsToEdit.finish_to,
      notes_id: propsToEdit.notes_id,
      linked_files_id: propsToEdit.linked_files_id,
      responsible_id: propsToEdit.responsible_id,
      task_id: taskId,
      inform_users: propsToEdit.inform_users,
      priority_id: propsToEdit.priority_id,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )
  return response?.data
}

export async function addTaskSession(payload: {
  task_id: number
  start: number
  end?: number
  active: boolean
}) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.post(
    SERVER_URL + TASK_SESSION_ADD_ENDPOINT,
    {
      task_id: payload.task_id,
      end: payload.end,
      active: payload.active,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  )
  return response.data
}

export async function finishTaskSession({ sessionId, userId }: DictType) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.post(
    SERVER_URL + TASK_SESSION_FINISH_ENDPOINT + `/${sessionId}`,
    {
      user_id: userId,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  )
  return response.data
}

export async function deleteTaskSession(sessionId: number) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.delete(SERVER_URL + TASK_SESSION_DELETE_ENDPOINT + `/${sessionId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
  return response.data
}

export const getTotalTime = (sessions: Array<DictType>) => {
  let total = 0
  sessions?.forEach((session) => {
    if (!session.in_progress) {
      const temp = session.end - session.start
      total = total += temp
    }
    return total
  })

  return total
}

export async function getTaskById(taskId: number) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  try {
    const response = await axios.get(SERVER_URL + TASK_BY_ID_ENDPOINT + taskId, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
    return response?.data
  } catch (error) {
    return error
  }
}

export async function setCompanyAccess(companySettings: CompanyAccessProps) {
  try {
    const accessToken = parseCookies()[ACCESS_TOKEN]

    const url = SERVER_URL + COMPANY_SETTINGS_SET_ENDPOINT
    let urlWithParams = new URL(url)
    const response = await axios.post(
      urlWithParams.toString(),
      {
        organization_id: companySettings.organization_id,
        project_view_only_members: companySettings.project_view_only_members,
        diary_location_mandatory: companySettings.diary_location_mandatory,
        owner_can_delete_project: companySettings.owner_can_delete_project,
        project_edit_only_owner: companySettings.project_edit_only_owner,
        organization_accout_have_full_access: companySettings.organization_accout_have_full_access,
        user_properties_edit_only_organization_account:
          companySettings.user_properties_edit_only_organization_account,
        dictionary_edit_only_organization_account:
          companySettings.dictionary_edit_only_organization_account,
        add_new_project_only_organization_account:
          companySettings.add_new_project_only_organization_account,
        teams_edit_only_organization_account: companySettings.teams_edit_only_organization_account,
        folders_managment_only_project_owner: companySettings.folders_managment_only_project_owner,
        file_delete_by_project_members: companySettings.file_delete_by_project_members,
        inform_by_email: companySettings.inform_by_email ? 1 : 0,
        inform_by_whatsapp: companySettings.inform_by_whatsapp ? 1 : 0,
      },
      {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      },
    )
    return response
  } catch (error) {
    return error
  }
}

//task-group

export async function addTaskGroup(payload: { project_id: number; group_name: string }) {
  const accessToken = parseCookies()[ACCESS_TOKEN]

  const response = await axios.post(
    SERVER_URL + TASK_GROUP_ADD,
    {
      project_id: payload.project_id,
      group_name: payload.group_name,
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  )
  return response.data
}

// map helper functions to get mid point of a line

export const getMidPoint = (coords: any[]) => {
  let line = turf.lineString(coords)
  var length = turf.length(line, { units: "degrees" })
  var midpoint = turf.along(line, length / 2, { units: "degrees" })
  var midpointCoordinates = midpoint.geometry.coordinates

  return midpointCoordinates
}

// process end points

export const getWFSFeatures = async (bbox: any, layername: string, url: string) => {
  const bboxFilter = `
      <ogc:Filter xmlns:ogc="http://www.opengis.net/ogc" xmlns:gml="http://www.opengis.net/gml">
        <ogc:BBOX>
          <ogc:PropertyName>Shape</ogc:PropertyName>
          <gml:Box srsName="urn:x-ogc:def:crs:EPSG:4326">
            <gml:coordinates>${bbox._sw.lat},${bbox._sw.lng}, ${bbox._ne.lat},${bbox._ne.lng}</gml:coordinates>
          </gml:Box>
        </ogc:BBOX>
      </ogc:Filter>
    `
  try {
    const response = await axios.get(url, {
      params: {
        service: "wfs",
        request: "GetFeature",
        typeName: layername, // Replace with the name of the specific feature type (layer) you want to access
        outputFormat: "geojson", // Request the data in GeoJSON format,
        Filter: bboxFilter,
      },
    })

    return response.data
  } catch (error) {
    console.log(error)
    return null
  }
}

const getDrawControl = (map: any) => {
  let drawControl
  if (map && map._controls) {
    for (const control of map._controls) {
      if (control instanceof MapboxDraw) {
        drawControl = control
        break
      }
    }
  }
  return drawControl
}

//  helper to  convert the annotation to  features
export const CovertAnnotationsToFeatures = (a: MapAnnatotaions[]) => {
  return a.map((i) => {
    let geom = {
      type: "Point",
      coordinates: [i.lon, i.lat],
    }

    let feature = turf.feature(geom)
    feature.properties = { annotation: i.annotation, id: i.id }

    return feature as unknown as AnnotationFeature
  })
}

export const formatCurrency = (value: number, isHebrew: boolean) => {
  return new Intl.NumberFormat(isHebrew ? "he" : "en-US", {
    style: "currency",
    currency: "ILS",
  }).format(value)
}

export const handleFileType = (file: DictType) => {
  const fileName = file?.name.replace(/\.[^/.]+$/, "").toLowerCase()
  if (fileName == file?.type?.toLowerCase()) return "txt"
  else if (file?.type == "") return "txt"
  else return file?.type
}

export const formatTimeTacker = (timeInMilliseconds: any, { toNow, amPm, duration }: DictType) => {
  const timeDiff = Date.now() - timeInMilliseconds
  let timeMilliseconds = toNow ? timeDiff : timeInMilliseconds
  if (amPm) {
    const timestamp = timeInMilliseconds
    const date = new Date(timestamp)
    const hours = date.getHours()
    const minutes = date.getMinutes()

    // Format hours in 12-hour format
    const formattedHours = hours % 12 || 12

    // Determine AM/PM suffix
    const amPm = hours < 12 || hours === 24 ? "AM" : "PM"

    // Format minutes to have two digits
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes

    return `${formattedHours}:${formattedMinutes} ${amPm}`
  }
  if (duration) {
    timeMilliseconds = timeInMilliseconds
  }
  const totalSeconds = Math.floor(timeMilliseconds / 1000)
  const seconds = totalSeconds % 60
  const minutes = Math.floor(totalSeconds / 60) % 60
  const hours = Math.floor(totalSeconds / 3600)

  const formattedHours = hours < 10 ? "0" + hours : hours
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes
  const formattedSeconds = seconds < 10 ? "0" + seconds : seconds

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
}

// --- Date/time helpers for project custom columns --------------------------

const pad2 = (n: number): string => String(n).padStart(2, "0")

export const toUnixTimestamp = (datetimeStr: string): number =>
  Math.floor(new Date(datetimeStr).getTime() / 1000)

export const fromUnixTimestamp = (timestamp: number | string): string => {
  const ts = Number(timestamp)
  if (isNaN(ts) || !ts) return ""
  const d = new Date(ts * 1000)
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}T${pad2(d.getHours())}:${pad2(d.getMinutes())}`
}

export const formatDateTimeDisplay = (d: Date): string => {
  const hours = d.getHours()
  const h12 = pad2(hours % 12 || 12)
  const ampm = hours >= 12 ? "PM" : "AM"
  return `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()} ${h12}:${pad2(d.getMinutes())} ${ampm}`
}

export const formatDateDisplay = (d: Date): string =>
  `${pad2(d.getDate())}-${pad2(d.getMonth() + 1)}-${d.getFullYear()}`

export const formatDateKey = (d: Date): string =>
  `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`

export const formatTimeInput = (d: Date | undefined | null): string =>
  d ? `${pad2(d.getHours())}:${pad2(d.getMinutes())}` : ""

export const parseDateRangeValue = (
  raw: unknown,
): { from?: Date; to?: Date } => {
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw || "{}") : raw || {}
    return {
      from: parsed.from ? new Date(Number(parsed.from) * 1000) : undefined,
      to: parsed.to ? new Date(Number(parsed.to) * 1000) : undefined,
    }
  } catch {
    return {}
  }
}

export const isImageUrl = (url?: string | null): boolean =>
  !!url && /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(url)

export const isHttpUrl = (v: unknown): v is string =>
  typeof v === "string" && /^https?:\/\//i.test(v.trim())
